import React from 'react';
import WordApp from './App';

function AppRouter() {
  return <WordApp />;
}

export default AppRouter;
